// page-fadein-out

jQuery(window).on('load', function () {
  jQuery('body').addClass('fade-in');
  setTimeout(function () {
  jQuery('.page-wrapper').css('opacity', '1');
  }, 600);
  setTimeout(function () {
  jQuery('body').addClass('fade-current');
  }, 1000);
  });
  /*
  jQuery(function() {
  jQuery('a:not([href^="#"]):not([target]):not([class="not-fade"])').on('click', function(e){
  e.preventDefault(); 
  url = jQuery(this).attr('href'); 
  if (url !== '') {
  jQuery('body').addClass('fade-out'); 
  setTimeout(function(){
  window.location = url; 
  }, 600);
  }
  return false;
  });
  });
  */
  
  jQuery(function() {
  var header = jQuery('.header');
  jQuery(window).scroll(function() {
  if (jQuery(this).scrollTop() > 0) {
  header.addClass('shown');
  } else {
  header.removeClass('shown');
  }
  });
  });
  jQuery(function() {
  /* slider */
  jQuery(window).on('load', function() {
  var mySwiper = new Swiper('.swiper-p-index', {
  loop: true,
  autoplay: {
  delay: 4000,
  disableOnInteraction: false,
  },
  effect: 'fade',
  speed: 2000,
  pagination: {
  el: '.swiper-pagination_index',
  },
  });
  var mySwiper = new Swiper('.swiper-result', {
  loop: true,
  loopedSlides: 12,
  slidesPerView: 2,
  centeredSlides: true,
  spaceBetween: 30,
  speed: 2000,
  autoplay: {
  disableOnInteraction: false,
  },
  breakpoints: {
  600: {
  slidesPerView: 4.5,
  spaceBetween: 40,
  }
  },
  pagination: {
  el: '.swiper-pagination',
  clickable: true,
  },
  navigation: {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev',
  },
  });
  var mySwiper = new Swiper('.swiper-voice', {
  loop: true,
  loopedSlides: 7,
  slidesPerView: 1.6,
  centeredSlides: true,
  spaceBetween: 0,
  speed: 2000,
  autoplay: {
  disableOnInteraction: false,
  },
  breakpoints: {
  600: {
  spaceBetween: 100,
  slidesPerView: 3.2,
  }
  },
  pagination: {
  el: '.swiper-pagination',
  clickable: true,
  },
  navigation: {
  nextEl: '.swiper-button-next',
  prevEl: '.swiper-button-prev',
  },
  });
  var mySwiper = new Swiper('.swiper-shop', {
  loop: true,
  slidesPerView: 1,
  centeredSlides: true,
  speed: 2000,
  autoplay: {
  disableOnInteraction: false,
  },
  pagination: {
  el: '.swiper-pagination',
  clickable: true,
  },
  });
  });
  });
  /* parallax */
  /*
  jQuery(function() {
  var rellax = new Rellax(' .rellax ');
  });
  */
  /* js-scroll */
  
  
  // readmore
  
  jQuery(function($) {
  jQuery(".c-btn-readmore").on("click", function() {
  jQuery(this).toggleClass("on-click");
  });
  jQuery(".readmore-1").on("click", function() {
  jQuery(".hidden-1").slideToggle(500);
  });
  jQuery(".readmore-2").on("click", function() {
  jQuery(".hidden-2").slideToggle(500);
  });
  jQuery(".readmore-3").on("click", function() {
  jQuery(".hidden-3").slideToggle(500);
  });
  jQuery(".readmore-4").on("click", function() {
  jQuery(".hidden-4").slideToggle(500);
  });
  jQuery(".readmore-5").on("click", function() {
  jQuery(".hidden-5").slideToggle(500);
  });
  jQuery(".readmore-6").on("click", function() {
  jQuery(".hidden-6").slideToggle(500);
  });
  });
  
  
  // faq
  
  jQuery(function() {
  jQuery(".c-faq dt").on("click", function() {
  jQuery(this).next('dd').slideToggle(200);
  jQuery(this).toggleClass('active');
  });
  });
  
  
  // accordion
  // 
  jQuery(function(){
  $('.c-accordion__btn').each(function(){
  $(this).on('click',function(){
  $(this).toggleClass('active');
  $("+.c-accordion__body",this).slideToggle()
  return false;
  });
  });
  });
  
  
  // nav
  
  jQuery(function() {
  jQuery('#nav-toggle').on('click', function() {
  jQuery('body').toggleClass('open');
  });
  });
  

  //追加

    // 動きのきっかけとなるアニメーションの名前を定義
function fadeAnime(){

  // ふわっ
  $('.js-scroll').each(function(){ //fadeUpTriggerというクラス名が
    var elemPos = $(this).offset().top-50;//要素より、50px上の
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    if (scroll >= elemPos - windowHeight){
    $(this).addClass('shown');// 画面内に入ったらfadeUpというクラス名を追記
    }else{
      $(this).removeClass('shown');
    }
    });
}

// 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function (){
    fadeAnime();/* アニメーション用の関数を呼ぶ*/
  });// ここまで画面をスクロールをしたら動かしたい場合の記述





  
    /*tab*/
    /*
jQuery(document).ready(function(){
  jQuery('.mod-tab-nav').tab({
    speed: 400, hash: true, hashMoveDisabled: true,
  });
});
*/


jQuery(function( $ ) {
  jQuery( 'input[name="zip"]' ).keyup( function( e ) {
AjaxZip3.zip2addr( this, '', 'your-prefecture', 'your-address' );
  } )
if($('#mw_wp_form_mw-wp-form-xxxx').hasClass('mw_wp_form mw_wp_form_confirm')){
  $(".comments").css('display', 'none');
}
} );
jQuery(".list-kit li").click(function() {
$(".list-kit li").removeClass("current"), $(this).addClass("current");
var t = $(this).find(".title").text();
$("#form-kit").val(t)
});
jQuery(function( $ ) {
document.onkeypress = submit_cancel;
function submit_cancel(){
  if( window.event.keyCode == 13 ){
      return false;
  }
}
});
// page-fadein-out

jQuery(window).on('load', function () {
jQuery('body').addClass('fade-in');
setTimeout(function () {
jQuery('.page-wrapper').css('opacity', '1');
}, 600);
setTimeout(function () {
jQuery('body').addClass('fade-current');
}, 1000);
});

jQuery(function() {
jQuery('a:not([href^="#"]):not([target])').on('click', function(e){
e.preventDefault(); 
url = jQuery(this).attr('href'); 
if (url !== '') {
jQuery('body').addClass('fade-out'); 
setTimeout(function(){
window.location = url; 
}, 600);
}
return false;
});
});

window.onpageshow = function(event) {
if (event.persisted) {

jQuery('body').removeClass('fade-out'); 

}
};


$(function(){
  var min_height = 150; //initial height.
  var ani_duration = 500;
  $('.text_wrapper').each(function(index) {
    if ($(this).height()>min_height + 50) {  
      $(this).height(min_height).append('<div class="show_more"></div>');
    }
  });

  $('.show_more').click(function(){
      var athis = $(this);
      var show_text = athis.parent('.text_wrapper');
      var original_height = show_text.css({height : 'auto'}).height();

      if(show_text.hasClass('open')){
        //--CLOSE--
        var scroll_offset = $("html,body").scrollTop() - original_height + min_height;

        $("html,body").animate({ scrollTop: scroll_offset }, ani_duration);
        show_text.animate({height:min_height}, ani_duration, function(){
        });
        show_text.removeClass('active').removeClass('open');
      }else{
          //--OPEN--
          show_text.height(min_height).animate({height:original_height},ani_duration, function(){
          show_text.height('auto').addClass('open');
        });
        show_text.addClass('active');
      }
  });
})




/* たぶ */
//任意のタブにURLからリンクするための設定
$(function(){
  $(".fv .js-scroll").each(function(){
    $(this).addClass("shown");
  });


  function GethashID (hashIDName){
    if(hashIDName){
      //タブ設定
      $('.mod-tab-nav li').find('a').each(function() { //タブ内のaタグ全てを取得
        var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得
        if(idName == hashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
          var parentElm = $(this).parent().parent(); //タブ内のaタグの親要素（li）を取得
          $('.mod-tab-nav li').removeClass("current"); //タブ内のliについているactiveクラスを取り除き
          $(parentElm).addClass("current"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
          //表示させるエリア設定
          $(".mod-tab-contents-item").removeClass("current"); //もともとついているis-activeクラスを取り除き
          $(hashIDName).addClass("current"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加 
        }
      });
    }
  }
  
  //タブをクリックしたら
  $('.mod-tab-nav a').on('click', function() {
    var idName = $(this).attr('href'); //タブ内のリンク名を取得  
    GethashID (idName);//設定したタブの読み込みと
    return false;//aタグを無効にする
  });
  
  
  // 上記の動きをページが読み込まれたらすぐに動かす
  $(window).on('load', function () {
      $('.mod-tab-nav li:first-of-type').addClass("current"); //最初のliにactiveクラスを追加
      $('.mod-tab-contents-item:first-of-type').addClass("current"); //最初の.areaにis-activeクラスを追加
    var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
    GethashID (hashName);//設定したタブの読み込み
  });
    
});

